import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import fr from "./filter.js";
import { isArray as D } from "../../util/code-utils.js";
var is = /*#__PURE__*/function () {
  function is(t) {
    _classCallCheck(this, is);
    this.filters = t, this.filters = t;
  }
  _createClass(is, [{
    key: "xc",
    value: function xc(t) {
      var r = !0;
      for (var e = 0; e < this.filters.length; e++) {
        var o = this.filters[e];
        var s = !1;
        for (var _r = 0; _r < o.length; _r++) if (o[_r].xc(t)) {
          s = !0;
          break;
        }
        if (!s) {
          r = !1;
          break;
        }
      }
      return r;
    }
  }, {
    key: "dt",
    value: function dt() {
      var t = [];
      for (var r = 0; r < this.filters.length; r++) {
        var e = this.filters[r],
          o = [];
        for (var _t = 0; _t < e.length; _t++) o.push(e[_t].dt());
        t.push(o);
      }
      return t;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      if (null == t || !D(t)) return null;
      var r = [];
      for (var e = 0; e < t.length; e++) {
        var o = [],
          s = t[e];
        for (var _t2 = 0; _t2 < s.length; _t2++) o.push(fr.fromJson(s[_t2]));
        r.push(o);
      }
      return new is(r);
    }
  }, {
    key: "qn",
    value: function qn(t) {
      var r = [];
      for (var e = 0; e < t.length; e++) {
        var o = [],
          s = t[e];
        for (var _t3 = 0; _t3 < s.length; _t3++) o.push(fr.qn(s[_t3]));
        r.push(o);
      }
      return new is(r);
    }
  }]);
  return is;
}();
export { is as default };